// extracted by mini-css-extract-plugin
module.exports = {"main_column":"UserPermissions_main_column__3NcdC"};